import React from 'react';
import UserBadge from './UserBadge';

interface UserHeaderProps {
  title: string;
}

const UserHeader: React.FC<UserHeaderProps> = ({ title }) => {
  return (
    <div className="d-flex justify-content-between align-items-center mb-4">
      <h3 style={{ color: '#687088', fontWeight: 500 }}>{title}</h3>
      <UserBadge />
    </div>
  );
};

export default UserHeader;
